/* ============================================================
   K.NOAH — GET YOUR QUOTE V5
   FINAL SINGLE QUOTE FORM
   ============================================================ */

(function () {

  'use strict';


  if (window.KN_QUOTE_PAGE_V5) return;
  window.KN_QUOTE_PAGE_V5 = true;


  /* ============================================================
     HELPERS
     ============================================================ */

  function getReview() {

    return document.getElementById(
      'kn57-review'
    );

  }


  function getReviewButton() {

    return document.querySelector(
      '#kn-part-switch-inner [data-kn-part="review"]'
    );

  }


  function cleanText(value) {

    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();

  }


  /* ============================================================
     CLEAN LEGACY ELEMENTS
     ============================================================ */

  function cleanLegacy() {

    /* Old request form */

    var oldRequest =
      document.getElementById(
        'knr-request'
      );

    if (oldRequest) {
      oldRequest.remove();
    }


    /* Old download navigation */

    document
      .querySelectorAll(
        '#kn-part-switch-inner [data-kn-part="download"]'
      )
      .forEach(function (element) {

        element.remove();

      });


    /* Old download page */

    var oldDownload =
      document.getElementById(
        'kn-download-design-page'
      );

    if (oldDownload) {
      oldDownload.remove();
    }

  }


  /* ============================================================
     NAVIGATION
     ============================================================ */

  function updateNavigation() {

    var button =
      getReviewButton();

    if (!button) return;


    var span =
      button.querySelector('span');

    if (span) {

      span.textContent =
        'GET YOUR QUOTE';

    } else {

      button.textContent =
        'GET YOUR QUOTE';

    }

  }


  /* ============================================================
     CONFIGURATION DATA
     ============================================================ */

  function getConfigGrid() {

    var review =
      getReview();

    if (!review) return null;


    return review.querySelector(
      '.kn57-grid'
    );

  }


  function getConfigurationText() {

    var grid =
      getConfigGrid();

    if (!grid) return '';


    return cleanText(
      grid.innerText ||
      grid.textContent ||
      ''
    );

  }


  function getPartConfiguration(type) {

    var grid =
      getConfigGrid();

    if (!grid) return '';


    var cards =
      Array.from(
        grid.children
      );


    var wanted =
      type.toLowerCase();


    var card =
      cards.find(function (item) {

        var text =
          cleanText(
            item.innerText ||
            item.textContent ||
            ''
          ).toLowerCase();


        return text.indexOf(
          wanted
        ) !== -1;

      });


    if (!card) return '';


    return cleanText(
      card.innerText ||
      card.textContent ||
      ''
    );

  }


  /* ============================================================
     BUILD EMAIL MESSAGE
     ============================================================ */

  function buildMessage(form) {

    var product =
      form.querySelector(
        'input[name="knq-product"]:checked'
      );


    var quantity =
      form.querySelector(
        '#knq-quantity'
      );


    var name =
      form.querySelector(
        '#knq-name'
      );


    var team =
      form.querySelector(
        '#knq-team'
      );


    var email =
      form.querySelector(
        '#knq-email'
      );


    var phone =
      form.querySelector(
        '#knq-phone'
      );


    var message =
      form.querySelector(
        '#knq-message'
      );


    var jersey =
      getPartConfiguration(
        'jersey'
      );


    var pants =
      getPartConfiguration(
        'pants'
      );


    var complete =
      getConfigurationText();


    var output = [];


    output.push(
      'K.NOAH — NEW UNIFORM QUOTE REQUEST'
    );

    output.push('');
    output.push('--------------------------------');
    output.push('CUSTOMER');
    output.push('--------------------------------');

    output.push(
      'Name: ' +
      cleanText(name ? name.value : '')
    );

    output.push(
      'Team / Organization: ' +
      cleanText(team ? team.value : '')
    );

    output.push(
      'Email: ' +
      cleanText(email ? email.value : '')
    );

    output.push(
      'Phone: ' +
      cleanText(phone ? phone.value : '')
    );


    output.push('');
    output.push('--------------------------------');
    output.push('REQUEST');
    output.push('--------------------------------');

    output.push(
      'Product: ' +
      (
        product
          ? product.value
          : 'Full Uniform'
      )
    );

    output.push(
      'Quantity: ' +
      (
        quantity
          ? quantity.value
          : ''
      )
    );


    if (jersey) {

      output.push('');
      output.push('--------------------------------');
      output.push('JERSEY CONFIGURATION');
      output.push('--------------------------------');
      output.push(jersey);

    }


    if (pants) {

      output.push('');
      output.push('--------------------------------');
      output.push('PANTS CONFIGURATION');
      output.push('--------------------------------');
      output.push(pants);

    }


    if (
      !jersey &&
      !pants &&
      complete
    ) {

      output.push('');
      output.push('--------------------------------');
      output.push('CONFIGURATION');
      output.push('--------------------------------');
      output.push(complete);

    }


    output.push('');
    output.push('--------------------------------');
    output.push('MESSAGE / NOTES');
    output.push('--------------------------------');

    output.push(
      cleanText(
        message
          ? message.value
          : ''
      )
    );


    output.push('');
    output.push(
      'Sent via K.NOAH Uniform Configurator.'
    );


    return output.join('\n');

  }


  /* ============================================================
     HERO
     ============================================================ */

  function updateHero(review) {

    var kicker =
      review.querySelector(
        ':scope > small'
      );


    var title =
      review.querySelector(
        ':scope > h2'
      );


    var intro =
      review.querySelector(
        ':scope > .kn57-intro'
      );


    if (kicker) {

      kicker.textContent =
        'FINAL STEP';

    }


    if (title) {

      title.textContent =
        'GET YOUR QUOTE';

    }


    if (intro) {

      intro.textContent =
        'Your uniform is ready. Review your configuration and send us your request for a personal quote.';

    }

  }


  /* ============================================================
     BUILD INTRO
     ============================================================ */

  function buildIntro(review, grid) {

    if (
      document.getElementById(
        'knq-intro'
      )
    ) {
      return;
    }


    var intro =
      document.createElement(
        'section'
      );


    intro.id =
      'knq-intro';


    intro.innerHTML = `

      <span class="knq-eyebrow">
        YOUR DESIGN. YOUR TEAM.
      </span>

      <h3>
        READY TO BRING IT TO LIFE?
      </h3>

      <p>
        Review your selections below and send us your
        requirements. Our team will check your design,
        quantity and production details before getting
        back to you with your personal quote.
      </p>

    `;


    review.insertBefore(
      intro,
      grid
    );

  }


  /* ============================================================
     CONFIG HEADER
     ============================================================ */

  function buildConfigHeader(
    review,
    grid
  ) {

    if (
      document.getElementById(
        'knq-config-head'
      )
    ) {
      return;
    }


    var header =
      document.createElement(
        'div'
      );


    header.id =
      'knq-config-head';


    header.innerHTML = `

      <span class="knq-eyebrow">
        YOUR CONFIGURATION
      </span>

      <h3>
        CHECK YOUR SELECTIONS.
      </h3>

      <p>
        Review your current Jersey and Pants configuration.
        You can still return and make changes before
        sending your request.
      </p>

    `;


    review.insertBefore(
      header,
      grid
    );

  }


  /* ============================================================
     BUILD FORM
     ============================================================ */

  function buildForm(review) {

    if (
      document.getElementById(
        'knq-form'
      )
    ) {
      return;
    }


    var form =
      document.createElement(
        'form'
      );


    form.id =
      'knq-form';


    /*
      Shopify native contact endpoint.
    */

    form.method =
      'post';

    form.action =
      '/contact#knq-form';

    form.acceptCharset =
      'UTF-8';


    form.innerHTML = `

      <input
        type="hidden"
        name="form_type"
        value="contact">

      <input
        type="hidden"
        name="utf8"
        value="✓">

      <input
        type="hidden"
        name="contact[subject]"
        value="K.NOAH — New Uniform Quote Request">

      <textarea
        id="knq-body"
        name="contact[body]"
        hidden></textarea>


      <!-- ================================================
           REQUEST
           ================================================ -->

      <section class="knq-box">

        <div class="knq-heading-row">

          <span class="knq-number">
            01
          </span>

          <div>

            <span class="knq-eyebrow">
              YOUR REQUEST
            </span>

            <h3>
              WHAT DO YOU NEED?
            </h3>

          </div>

        </div>


        <div class="knq-products">

          <label>

            <input
              type="radio"
              name="knq-product"
              value="Jersey">

            <span>
              JERSEY
            </span>

          </label>


          <label>

            <input
              type="radio"
              name="knq-product"
              value="Pants">

            <span>
              PANTS
            </span>

          </label>


          <label>

            <input
              type="radio"
              name="knq-product"
              value="Full Uniform"
              checked>

            <span>
              FULL UNIFORM
            </span>

          </label>

        </div>


        <div class="knq-quantity-row">

          <div>

            <strong>
              QUANTITY
            </strong>

            <small>
              Estimated number of uniforms
            </small>

          </div>


          <div class="knq-quantity">

            <button
              type="button"
              data-knq-change="-1">
              −
            </button>

            <input
              id="knq-quantity"
              type="number"
              min="1"
              value="12"
              inputmode="numeric">

            <button
              type="button"
              data-knq-change="1">
              +
            </button>

          </div>

        </div>

      </section>


      <!-- ================================================
           CONTACT
           ================================================ -->

      <section class="knq-box">

        <div class="knq-heading-row">

          <span class="knq-number">
            02
          </span>

          <div>

            <span class="knq-eyebrow">
              CONTACT DETAILS
            </span>

            <h3>
              WHERE SHOULD WE REACH YOU?
            </h3>

          </div>

        </div>


        <div class="knq-fields">


          <div class="knq-field">

            <label for="knq-name">
              NAME *
            </label>

            <input
              id="knq-name"
              name="contact[name]"
              type="text"
              autocomplete="name"
              placeholder="Your name"
              required>

          </div>


          <div class="knq-field">

            <label for="knq-team">
              TEAM / ORGANIZATION *
            </label>

            <input
              id="knq-team"
              name="contact[team]"
              type="text"
              autocomplete="organization"
              placeholder="Your team"
              required>

          </div>


          <div class="knq-field">

            <label for="knq-email">
              EMAIL *
            </label>

            <input
              id="knq-email"
              name="contact[email]"
              type="email"
              autocomplete="email"
              placeholder="you@team.com"
              required>

          </div>


          <div class="knq-field">

            <label for="knq-phone">
              PHONE
            </label>

            <input
              id="knq-phone"
              name="contact[phone]"
              type="tel"
              autocomplete="tel"
              placeholder="+43 ...">

          </div>


          <div class="knq-field knq-full">

            <label for="knq-message">
              MESSAGE
            </label>

            <textarea
              id="knq-message"
              placeholder="Deadline, season, special requirements or anything else we should know..."></textarea>

          </div>


        </div>

      </section>


      <!-- ================================================
           SUBMIT
           ================================================ -->

      <div class="knq-submit-box">

        <div>

          <span>
            READY?
          </span>

          <p>
            Send us your configuration. Our team will
            review your request and get back to you personally.
          </p>

        </div>


        <button
          type="submit"
          class="knq-submit">

          <span>
            REQUEST YOUR QUOTE
          </span>

          <b>
            →
          </b>

        </button>

      </div>


      <p class="knq-note">
        QUOTE REQUESTS ARE HANDLED BY THE K.NOAH TEAM.
      </p>

    `;


    review.appendChild(
      form
    );


    /* ---------------------------------------------------------
       QUANTITY
       --------------------------------------------------------- */

    form
      .querySelectorAll(
        '[data-knq-change]'
      )
      .forEach(function (button) {

        button.addEventListener(
          'click',
          function () {

            var input =
              form.querySelector(
                '#knq-quantity'
              );


            var value =
              parseInt(
                input.value || '1',
                10
              );


            var change =
              parseInt(
                button.dataset.knqChange,
                10
              );


            input.value =
              Math.max(
                1,
                value + change
              );

          }
        );

      });


    /* ---------------------------------------------------------
       SUBMIT
       --------------------------------------------------------- */

    form.addEventListener(
      'submit',
      function (event) {

        if (!form.checkValidity()) {

          event.preventDefault();

          form.reportValidity();

          return;

        }


        var body =
          form.querySelector(
            '#knq-body'
          );


        if (body) {

          body.value =
            buildMessage(
              form
            );

        }


        var submit =
          form.querySelector(
            '.knq-submit'
          );


        if (submit) {

          submit.disabled =
            true;

          submit.classList.add(
            'is-loading'
          );

          submit.innerHTML =
            '<span>SENDING REQUEST...</span>';

        }


        /*
          IMPORTANT:
          No preventDefault() here.

          Shopify receives the form normally.
        */

      }
    );

  }


  /* ============================================================
     BUILD PAGE
     ============================================================ */

  function buildPage() {

    cleanLegacy();
    updateNavigation();


    var review =
      getReview();


    if (!review) {
      return false;
    }


    updateHero(
      review
    );


    var grid =
      getConfigGrid();


    if (!grid) {
      return false;
    }


    /* Remove old V4 form if present */

    var oldV4 =
      document.getElementById(
        'knq-final-form'
      );

    if (oldV4) {
      oldV4.remove();
    }


    buildIntro(
      review,
      grid
    );


    buildConfigHeader(
      review,
      grid
    );


    grid.classList.add(
      'knq-config-grid'
    );


    buildForm(
      review
    );


    return true;

  }


  /* ============================================================
     CLICK HANDLER
     ============================================================ */

  function bindQuoteButton() {

    var button =
      getReviewButton();


    if (!button) {
      return false;
    }


    if (
      button.dataset.knQuoteV5Bound === '1'
    ) {
      return true;
    }


    button.dataset.knQuoteV5Bound =
      '1';


    button.addEventListener(
      'click',
      function () {

        setTimeout(
          buildPage,
          30
        );

        setTimeout(
          buildPage,
          120
        );

        setTimeout(
          buildPage,
          300
        );

      }
    );


    return true;

  }


  /* ============================================================
     CSS
     ============================================================ */

  function addStyles() {

    if (
      document.getElementById(
        'kn-quote-v5-css'
      )
    ) {
      return;
    }


    var style =
      document.createElement(
        'style'
      );


    style.id =
      'kn-quote-v5-css';


    style.textContent = `

      /* =====================================================
         LEGACY
         ===================================================== */

      #knr-request,
      #kn-download-design-page,
      #knq-final-form{
        display:none !important;
      }


      /* =====================================================
         REVIEW PAGE
         ===================================================== */

      #kn57-review{
        width:100% !important;
        max-width:1180px !important;
        margin:0 auto !important;
        padding:10px 4px 70px !important;
        box-sizing:border-box !important;
        color:#111 !important;
      }


      #kn57-review > small{
        display:block !important;
        margin-bottom:10px !important;
        font-size:9px !important;
        font-weight:900 !important;
        letter-spacing:.18em !important;
        color:#aaa !important;
      }


      #kn57-review > h2{
        margin:0 0 12px !important;
        font-size:clamp(40px,5vw,66px) !important;
        line-height:.95 !important;
        font-weight:900 !important;
        letter-spacing:-.04em !important;
      }


      #kn57-review > .kn57-intro{
        max-width:700px !important;
        margin:0 !important;
        font-size:13px !important;
        line-height:1.6 !important;
        color:#999 !important;
      }


      /* =====================================================
         TYPOGRAPHY
         ===================================================== */

      .knq-eyebrow{
        display:block !important;
        margin-bottom:9px !important;
        font-size:9px !important;
        line-height:1 !important;
        font-weight:900 !important;
        letter-spacing:.16em !important;
        color:#777 !important;
      }


      #knq-intro h3,
      #knq-config-head h3,
      .knq-box h3{
        margin:0 !important;
        font-size:25px !important;
        line-height:1 !important;
        font-weight:900 !important;
        letter-spacing:-.025em !important;
      }


      /* =====================================================
         INTRO
         ===================================================== */

      #knq-intro{
        margin-top:42px !important;
        padding:32px 34px !important;
        border:1px solid #ddd !important;
        border-radius:14px !important;
        background:#f8f8f6 !important;
      }


      #knq-intro p,
      #knq-config-head p{
        max-width:720px !important;
        margin:13px 0 0 !important;
        font-size:13px !important;
        line-height:1.6 !important;
        color:#999 !important;
      }


      /* =====================================================
         CONFIG
         ===================================================== */

      #knq-config-head{
        margin:48px 0 20px !important;
      }


      #kn57-review .kn57-grid{
        display:grid !important;
        grid-template-columns:repeat(2,minmax(0,1fr)) !important;
        gap:14px !important;
        margin-bottom:48px !important;
      }


      #kn57-review .kn57-card{
        border:1px solid #ddd !important;
        border-radius:14px !important;
        background:#fff !important;
        box-shadow:none !important;
      }


      #kn57-review .kn59-preview{
        display:none !important;
      }


      /* =====================================================
         FORM BOX
         ===================================================== */

      #knq-form{
        display:block !important;
        width:100% !important;
      }


      .knq-box{
        margin-bottom:16px !important;
        padding:30px 32px !important;
        border:1px solid #ddd !important;
        border-radius:14px !important;
        background:#fff !important;
      }


      .knq-heading-row{
        display:flex !important;
        align-items:flex-start !important;
        gap:16px !important;
        margin-bottom:28px !important;
      }


      .knq-number{
        display:flex !important;
        align-items:center !important;
        justify-content:center !important;
        flex:0 0 36px !important;
        width:36px !important;
        height:36px !important;
        border-radius:50% !important;
        background:#111 !important;
        color:#fff !important;
        font-size:9px !important;
        font-weight:900 !important;
      }


      /* =====================================================
         PRODUCT
         ===================================================== */

      .knq-products{
        display:grid !important;
        grid-template-columns:repeat(3,minmax(0,1fr)) !important;
        gap:10px !important;
      }


      .knq-products label{
        position:relative !important;
        cursor:pointer !important;
      }


      .knq-products input{
        position:absolute !important;
        opacity:0 !important;
        pointer-events:none !important;
      }


      .knq-products label span{
        display:flex !important;
        align-items:center !important;
        justify-content:center !important;
        min-height:56px !important;
        padding:12px !important;
        border:1px solid #d8d8d5 !important;
        border-radius:9px !important;
        background:#f8f8f6 !important;
        font-size:10px !important;
        font-weight:900 !important;
        letter-spacing:.06em !important;
        transition:.18s ease !important;
      }


      .knq-products input:checked + span{
        border-color:#111 !important;
        background:#111 !important;
        color:#fff !important;
      }


      /* =====================================================
         QUANTITY
         ===================================================== */

      .knq-quantity-row{
        display:flex !important;
        align-items:center !important;
        justify-content:space-between !important;
        gap:20px !important;
        margin-top:28px !important;
        padding-top:24px !important;
        border-top:1px solid #eee !important;
      }


      .knq-quantity-row strong{
        display:block !important;
        margin-bottom:5px !important;
        font-size:10px !important;
        letter-spacing:.08em !important;
      }


      .knq-quantity-row small{
        display:block !important;
        font-size:11px !important;
        color:#999 !important;
      }


      .knq-quantity{
        display:grid !important;
        grid-template-columns:46px 72px 46px !important;
        height:46px !important;
        overflow:hidden !important;
        border:1px solid #ddd !important;
        border-radius:9px !important;
      }


      .knq-quantity button{
        border:0 !important;
        background:#f6f6f4 !important;
        color:#111 !important;
        font-size:20px !important;
        font-weight:700 !important;
        cursor:pointer !important;
      }


      .knq-quantity input{
        width:72px !important;
        border:0 !important;
        border-left:1px solid #ddd !important;
        border-right:1px solid #ddd !important;
        border-radius:0 !important;
        text-align:center !important;
        font-weight:800 !important;
        outline:none !important;
      }


      .knq-quantity input::-webkit-inner-spin-button,
      .knq-quantity input::-webkit-outer-spin-button{
        -webkit-appearance:none !important;
      }


      /* =====================================================
         FIELDS
         ===================================================== */

      .knq-fields{
        display:grid !important;
        grid-template-columns:repeat(2,minmax(0,1fr)) !important;
        gap:16px !important;
      }


      .knq-full{
        grid-column:1 / -1 !important;
      }


      .knq-field label{
        display:block !important;
        margin-bottom:8px !important;
        font-size:9px !important;
        font-weight:900 !important;
        letter-spacing:.08em !important;
        color:#555 !important;
      }


      .knq-field input,
      .knq-field textarea{
        display:block !important;
        width:100% !important;
        margin:0 !important;
        padding:14px 15px !important;
        border:1px solid #d8d8d5 !important;
        border-radius:8px !important;
        outline:none !important;
        background:#fafaf8 !important;
        color:#111 !important;
        box-shadow:none !important;
        font:inherit !important;
      }


      .knq-field input{
        height:48px !important;
      }


      .knq-field textarea{
        min-height:125px !important;
        resize:vertical !important;
      }


      .knq-field input:focus,
      .knq-field textarea:focus{
        border-color:#111 !important;
        background:#fff !important;
      }


      /* =====================================================
         SUBMIT
         ===================================================== */

      .knq-submit-box{
        display:flex !important;
        align-items:center !important;
        justify-content:space-between !important;
        gap:30px !important;
        margin-top:18px !important;
        padding:28px 30px !important;
        border-radius:14px !important;
        background:#111 !important;
        color:#fff !important;
      }


      .knq-submit-box > div{
        max-width:530px !important;
      }


      .knq-submit-box > div > span{
        display:block !important;
        margin-bottom:7px !important;
        font-size:9px !important;
        font-weight:900 !important;
        letter-spacing:.14em !important;
        color:#888 !important;
      }


      .knq-submit-box p{
        margin:0 !important;
        font-size:12px !important;
        line-height:1.55 !important;
        color:#999 !important;
      }


      .knq-submit{
        display:flex !important;
        align-items:center !important;
        justify-content:space-between !important;
        gap:25px !important;
        flex:0 0 auto !important;
        min-width:280px !important;
        height:56px !important;
        padding:0 20px 0 22px !important;
        border:0 !important;
        border-radius:8px !important;
        background:#fff !important;
        color:#111 !important;
        font-size:10px !important;
        font-weight:900 !important;
        letter-spacing:.05em !important;
        cursor:pointer !important;
      }


      .knq-submit b{
        font-size:18px !important;
        font-weight:400 !important;
      }


      .knq-submit.is-loading{
        opacity:.6 !important;
        pointer-events:none !important;
      }


      .knq-note{
        margin:13px 0 0 !important;
        text-align:center !important;
        font-size:8px !important;
        font-weight:900 !important;
        letter-spacing:.12em !important;
        color:#aaa !important;
      }


      /* =====================================================
         QUOTE NAV
         ===================================================== */

      #kn-part-switch-inner [data-kn-part="review"]{
        background:#111 !important;
        color:#fff !important;
        border-color:#111 !important;
      }


      @media(min-width:901px){

        #kn-part-switch-inner{
          display:grid !important;
          grid-template-columns:
            repeat(3,minmax(0,1fr)) !important;
        }

      }


      /* =====================================================
         MOBILE
         ===================================================== */

      @media(max-width:900px){

        #kn57-review{
          padding:6px 0 45px !important;
        }


        #kn57-review > h2{
          font-size:39px !important;
        }


        #knq-intro{
          margin-top:28px !important;
          padding:24px 20px !important;
        }


        #knq-config-head{
          margin-top:38px !important;
        }


        #kn57-review .kn57-grid{
          grid-template-columns:1fr !important;
          gap:10px !important;
          margin-bottom:38px !important;
        }


        .knq-box{
          padding:23px 18px !important;
        }


        .knq-products{
          grid-template-columns:1fr !important;
          gap:7px !important;
        }


        .knq-quantity-row{
          align-items:flex-start !important;
          flex-direction:column !important;
        }


        .knq-fields{
          grid-template-columns:1fr !important;
        }


        .knq-full{
          grid-column:auto !important;
        }


        .knq-submit-box{
          align-items:stretch !important;
          flex-direction:column !important;
          padding:24px 19px !important;
        }


        .knq-submit{
          width:100% !important;
          min-width:0 !important;
        }

      }

    `;


    document.head.appendChild(
      style
    );

  }


  /* ============================================================
     INIT
     ============================================================ */

  function init() {

    cleanLegacy();

    addStyles();

    updateNavigation();

    bindQuoteButton();

    buildPage();


    var attempts = 0;


    var timer =
      setInterval(
        function () {

          attempts++;

          cleanLegacy();

          updateNavigation();

          bindQuoteButton();

          buildPage();


          if (attempts >= 40) {

            clearInterval(
              timer
            );

          }

        },
        250
      );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();